import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

// ─────────────────────────────────────────────────────────────
// cn：合併 className 的通用工具。
// clsx 處理條件式 class，twMerge 消解 Tailwind 衝突（後者勝）。
// shadcn 系列元件（src/components/ui/*）統一用此函式拼 class。
// ─────────────────────────────────────────────────────────────
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
